<template>
  <scrollable full>
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-col>
        <v-btn
          block
          @click="reactivateCampaign"
        >
          {{ $t('words.reactivation') }}
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          block
          @click="desactivateCampaign(30)"
        >
          {{ $t('words.disabled') }} 30 min
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          block
          @click="desactivateCampaign(60)"
        >
          {{ $t('words.disabled') }} 60 min
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          block
          @click="toggleShowPlageDesactivation"
        >
          {{ $t('words.deactivationRange') }}
        </v-btn>
      </v-col>
      <v-container v-if="showPlageDesactivation">
        <v-col
          v-for="(plage, index) in listPlage"
          :key="index"
        >
          <v-container
            class="plage-desactivation-item"
            :class="{'selected': plageSelected === index}"
            @click="clickPlage(index)"
          >
            <span class="title">
              {{ plage.title }}
            </span>
            <span>{{ plage.value }}</span>
          </v-container>
        </v-col>
      </v-container>

      <v-divider class="my-2" />

      <div style="text-align: center;">
        <v-btn
          color="red"
          @click="deactivatePlage"
        >
          {{ $t('words.disable') }}
        </v-btn>
        <v-btn
          color="green"
          @click="validPlage"
        >
          {{ $t('words.valid') }}
        </v-btn>
      </div>
    </v-card>

    <tabs
      v-model="tabParametrage"
      :headers="['Dons', 'Pourboire']"
    >
      <v-tab v-if="donationCampaign !== undefined">
        {{ $t('title.donations') }}
      </v-tab>
      <v-tab v-if="tipCampaign !== undefined">
        {{ $t('title.tips') }}
      </v-tab>
    </tabs>
    <v-tabs-items
      id="custom-tab-items"
      v-model="tabParametrage"
    >
      <!-- ***** TAB campaign Don ***** -->
      <v-tab-item
        v-if="donationCampaign !== undefined"
        style="background-color: transparent;"
      >
        <v-card
          flat
          class="pa-3"
        >
          <div class="bloc headline">
            {{ $t('field.settings.seuil_min') }}
          </div>

          <div class="amount-seuil-min">
            <v-icon
              class="mr-3"
              @click="toggleShowKeyboard"
            >
              {{ IconEnum.edit }}
            </v-icon>
            <span>{{ seuil !== null ? $amount(seuil) : $t('field.settings.any_minimal_threshold') }}</span>
          </div>
          <v-divider class="my-2" />
          <div style="text-align: center;">
            <v-btn
              color="red"
              @click="deactivate"
            >
              {{ $t('words.disable') }}
            </v-btn>
          </div>
        </v-card>
      </v-tab-item>

      <!-- ***** TAB campaign Pourboire ***** -->
      <v-tab-item
        v-if="tipCampaign !== undefined"
        style="background-color: transparent;"
      >
        <v-card
          flat
          class="pa-3"
        >
          <div class="bloc headline">
            {{ $t('field.settings.seuil_min') }}
          </div>

          <div class="amount-seuil-min">
            <v-icon
              class="mr-3"
              @click="toggleShowKeyboard"
            >
              {{ IconEnum.edit }}
            </v-icon>
            <span>{{ seuil !== null ? $amount(seuil) : $t('field.settings.any_minimal_threshold') }}</span>
          </div>
          <v-divider class="my-2" />
          <div style="text-align: center;">
            <v-btn
              color="red"
              @click="deactivate"
            >
              {{ $t('words.disable') }}
            </v-btn>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <keyboard-dialog
      v-model="showKeyboard"
      use-default-screen
      auto-close
      @valid="validBtn"
    />

    <timer-picker-dialog
      v-model="showDateEntry"
      btn-class="right success"
      hide-overlay
      outlined
      @del="cancelHourPlage"
      @cancel="cancelHourPlage"
      @valid="validHourPlage"
    />
  </scrollable>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { $amount, $alert } from '@/modules/Utils'
import { IconEnum } from '@/modules/Enums'

import Tabs from '@/components/Tabs'
import TimerPickerDialog from '@/components/modal/TimerPickerDialog'
import KeyboardDialog from '@/components/modal/KeyboardDialog'

export default {
  name: 'CampaignSettings',

  components: {
    Tabs,
    TimerPickerDialog,
    KeyboardDialog
  },

  data () {
    return {
      IconEnum,
      showPlageDesactivation: false,
      showDateEntry: false,
      showKeyboard: false,
      plageSelected: null,
      tabParametrage: 0,
      seuilMinDon: null,
      seuilMinPourboire: null,
      listPlage: [
        { title: 'Plage 1 début', value: null },
        { title: 'Plage 1 fin', value: null },
        { title: 'Plage 2 début', value: null },
        { title: 'Plage 2 fin', value: null }
      ]
    }
  },

  computed: {
    paymentService () { return this.$store.getters.paymentService },
    // Type 1 = Don & Type 0 = Pourboire
    donationCampaign () { return this.$store.getters.donationCampaign },
    tipCampaign () { return this.$store.getters.tipCampaign },
    seuil: {
      get () { return this.tabParametrage === 0 ? this.seuilMinDon  : this.seuilMinPourboire },
      set (val) { this.tabParametrage === 0 ? this.seuilMinDon  = val : this.seuilMinPourboire = val }
    },
    plageValue: {
      // On récupère la valeur de la bonne plage selectionné
      get () {
        switch (this.plageSelected) {
          case 0: return this.listPlage[0].value
          case 1: return this.listPlage[1].value
          case 2: return this.listPlage[2].value
          case 3: return this.listPlage[3].value
          default: return null
        }
      },
      set (val) {
        switch (this.plageSelected) {
          case 0: this.listPlage[0].value = val
            break;
          case 1:  this.listPlage[1].value = val
            break;
          case 2:  this.listPlage[2].value = val
            break;
          case 3:  this.listPlage[3].value = val
            break;
          default: return null
        }
      }
    }
  },

  mounted () {
    this.seuilMinDon = this.donationCampaign.MontantMinimum
    this.seuilMinPourboire = this.tipCampaign.MontantMinimum

    if (MetierLocalStorage.getPlageArretCampagne1() != null) {
      this.listPlage[0].value = MetierLocalStorage.getPlageArretCampagne1().debut
      this.listPlage[1].value = MetierLocalStorage.getPlageArretCampagne1().fin
    }
    if (MetierLocalStorage.getPlageArretCampagne2() != null) {
      this.listPlage[3].value = MetierLocalStorage.getPlageArretCampagne2().fin
      this.listPlage[2].value = MetierLocalStorage.getPlageArretCampagne2().debut
    }
  },

  methods: {
    $amount,
    toggleShowKeyboard () {
      this.showKeyboard = !this.showKeyboard;

      if (this.showKeyboard) {
        this.plageSelected = null;
      }
    },
    toggleShowPlageDesactivation () {
      this.showPlageDesactivation = !this.showPlageDesactivation;
    },
    deactivate () {
      MetierLocalStorage.setSeuilMinCampagne(0)
      this.seuil = null;
      if (this.tabParametrage === 0) {
        let campaignDonCopyWith = this.donationCampaign
        campaignDonCopyWith.MontantMinimum = null;
        this.donationCampaign = campaignDonCopyWith
      } else {
        let tipCampaignCopyWith = this.tipCampaign
        tipCampaignCopyWith.MontantMinimum = null;
        this.tipCampaign = tipCampaignCopyWith
      }
    },
    validBtn (seuil) {
      MetierLocalStorage.setSeuilMinCampagne(seuil)
      this.seuil = seuil
      if (this.tabParametrage === 0) {
        let campaignDonCopyWith = this.donationCampaign
        campaignDonCopyWith.MontantMinimum = this.seuilMinDon;
        this.donationCampaign = campaignDonCopyWith
      } else {
        let tipCampaignCopyWith = this.tipCampaign
        tipCampaignCopyWith.MontantMinimum = this.seuilMinPourboire;
        this.tipCampaign = tipCampaignCopyWith
      }
      $alert(this.$i18n.t('success.campaign_seuil_min_success'), 'success')
      this.showKeyboard = false;
    },
    reactivateCampaign () {
      $alert(this.$i18n.t('success.campaign_reactivation_success'), 'success')
      this.$store.commit('campaignDeactivated', null)
    },
    desactivateCampaign (min) {
      $alert(this.$i18n.t('success.campaign_desactivation_success'), 'success')
      this.$store.commit('campaignDeactivated', min)
    },
    clickPlage (index) {
      this.plageSelected = index;
      this.showDateEntry = true;
    },
    validHourPlage (hour) {
      this.showDateEntry = false;
      this.plageValue = hour;
    },
    cancelHourPlage () {
      this.showDateEntry = false;
    },
    validPlage () {
      MetierLocalStorage.setPlageArretCampagne1({
        debut: this.listPlage[0].value,
        fin: this.listPlage[1].value,
      });

      MetierLocalStorage.setPlageArretCampagne2({
        debut: this.listPlage[2].value,
        fin: this.listPlage[3].value
      });
      $alert(this.$i18n.t('success.campaign_plagechange_success'), 'success')
      this.plageSelected = null;
    },
    deactivatePlage () {
      MetierLocalStorage.setPlageArretCampagne1(null);
      MetierLocalStorage.setPlageArretCampagne2(null);

      for (let i = 0; i < this.listPlage.length; i++) {
        this.listPlage[i].value = null;
      }
    }
  }
}
</script>

<style scoped>

</style>
